var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 5.83301V5.83301C11.6673 4.73718 11.6673 4.18927 11.3647 3.82048C11.3093 3.75297 11.2474 3.69107 11.1798 3.63566C10.8111 3.33301 10.2631 3.33301 9.16732 3.33301H6.00065C4.74357 3.33301 4.11503 3.33301 3.72451 3.72353C3.33398 4.11406 3.33398 4.7426 3.33398 5.99968V9.16634C3.33398 10.2622 3.33398 10.8101 3.63664 11.1789C3.69204 11.2464 3.75395 11.3083 3.82146 11.3637C4.19024 11.6663 4.73816 11.6663 5.83398 11.6663V11.6663",
    stroke: "#8DA4AD",
    strokeWidth: 1.33333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.33398,
    y: 8.33301,
    width: 8.33333,
    height: 8.33333,
    rx: 1.33333,
    stroke: "#8DA4AD",
    strokeWidth: 1.33333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCopyIcon);
export default __webpack_public_path__ + "static/media/footer_copy_icon.df86c0d9be9719df64bfc039180c8f5a.svg";
export { ForwardRef as ReactComponent };